module.exports = __webpack_public_path__ + "static/media/arrow-down-black.88b8da39.svg";